import React from 'react';
import { Container } from 'reactstrap';
import ImprovementClarification from './components/ImprovementClarification';

const ImprovementClarificationPage = () => {
  document.title = 'Improvement Clarification';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <ImprovementClarification />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ImprovementClarificationPage;
